var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 45,
    viewBox: "0 0 49 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_4363)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 44.3121,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6894 12.4075L0 28.9506V44.3122H40.18L13.6894 12.4075Z",
    fill: "url(#paint0_linear_603_4363)",
    stroke: "url(#paint1_linear_603_4363)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8 11.8165C33.8 14.895 31.7466 17.2248 29.4 17.2248C27.0534 17.2248 25 14.895 25 11.8165C25 8.73792 27.0534 6.4082 29.4 6.4082C31.7466 6.4082 33.8 8.73792 33.8 11.8165Z",
    fill: "white",
    stroke: "url(#paint2_linear_603_4363)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7099 17.7249L28.4199 30.1322L39.8122 43.9428H48.9999V30.7231L38.7099 17.7249Z",
    fill: "url(#paint3_linear_603_4363)",
    stroke: "url(#paint4_linear_603_4363)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 45,
    height: 40.3121,
    stroke: "url(#paint5_linear_603_4363)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_603_4363",
    x1: 2.74933e-7,
    y1: 33.9794,
    x2: 34.3655,
    y2: 11.3661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_603_4363",
    x1: 2.74933e-7,
    y1: 33.9794,
    x2: 34.3655,
    y2: 11.3661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_603_4363",
    x1: 24.5,
    y1: 13.8978,
    x2: 34.6123,
    y2: 9.51582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_603_4363",
    x1: 28.4199,
    y1: 35.4518,
    x2: 50.0113,
    y2: 26.5963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_603_4363",
    x1: 28.4199,
    y1: 35.4518,
    x2: 50.0113,
    y2: 26.5963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_603_4363",
    x1: 3.35284e-7,
    y1: 29.961,
    x2: 45.0251,
    y2: 3.94654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E9FDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F749F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_4363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 44.3121,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/UploadImage.6ca9041075d4ffa59c5ddf7ec1012990.svg";
export { ForwardRef as ReactComponent };